module.exports = __webpack_public_path__ + "static/media/CI landscape logo gr yellow 18x6.55d82605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CI landscape logo gr yellow 18x6.png
// module id = 1138
// module chunks = 0